import { Link } from "react-router-dom";

/**
 * LegalFooter — Slim, always-present footer with pointers to the key
 * legal documents. Rendered on marketing / signup / legal pages so Link Ride
 * is never more than one tap away from Terms + Privacy.
 *
 * Kept intentionally lightweight — no external dependencies, no state.
 */
export default function LegalFooter() {
  return (
    <footer
      className="w-full mt-16 border-t border-white/5 bg-black/60"
      data-testid="legal-footer"
    >
      <div className="max-w-6xl mx-auto px-5 py-6 space-y-3">
        <div
          className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs"
          data-testid="legal-footer-contact"
        >
          <a
            href="tel:+14845773677"
            className="inline-flex items-center gap-1.5 text-zinc-300 hover:text-[#4D88FF] transition-colors font-mono"
            data-testid="legal-footer-phone"
          >
            P · 484-577-3677
          </a>
          <span className="text-white/20">·</span>
          <a
            href="mailto:Link@LinkLitePro.com"
            className="inline-flex items-center gap-1.5 text-zinc-300 hover:text-[#4D88FF] transition-colors"
            data-testid="legal-footer-email"
          >
            E · Link@LinkLitePro.com
          </a>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
          <p className="text-zinc-600">
            © Link-Lite Data LLC · Link Ride is licensed software. Operators are responsible for local compliance.
          </p>
          <nav className="flex items-center gap-4">
            <Link
              to="/legal/terms"
              className="text-zinc-400 hover:text-[#4D88FF] transition-colors"
              data-testid="footer-terms-link"
            >
              Terms
            </Link>
            <Link
              to="/legal/privacy"
              className="text-zinc-400 hover:text-[#4D88FF] transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy
            </Link>
            <Link
              to="/legal"
              className="text-zinc-400 hover:text-[#4D88FF] transition-colors"
              data-testid="footer-legal-link"
            >
              All documents
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
